import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export const CTASection = () => {
  return <section className="py-6" data-id="element-17">
      <img src="https://media.giphy.com/media/6afY1gXRRAxe2tU9eP/giphy.gif" alt="Cat-related animated GIF" className="w-full h-auto object-cover rounded mb-6" data-id="element-18" />
      <div className="rounded-lg mb-6 overflow-hidden" data-id="element-19">
        <div className="bg-blue-500 p-3 flex items-center" data-id="element-20">
          <AlertTriangleIcon className="text-white mr-2" size={24} data-id="element-21" />
          <p className="font-bold text-white text-xl" data-id="element-22">UPDATE</p>
        </div>
        <div className="bg-yellow-50 p-4 border-x border-b border-yellow-200" data-id="element-23">
          <p className="text-[18px] text-[#323232]" data-id="element-24">
            <span className="text-red-500 font-medium" data-id="element-25">
              *Update: September 9, 2025*
            </span>{' '}
            Since this advertorial was originally published, there's been a
            tremendous "buzz" about Petssey DNRx and the company has seen a huge
            surge in Australian sales. While their inventory is now dwindling,
            they're still offering an{' '}
            <a href="https://petssey.com/products/petssey-dnrx" data-id="element-26">
            <span className="text-blue-600 font-medium" data-id="element-27">
              "Internet Only Promotion" and bundle discount.
            </span>{' '}
            </a>
            (This offer is only available while supplies last.) To find out if
            Petssey DNRx is still in stock, click the button below.
          </p>
        </div>
      </div>
      <div className="flex flex-col items-center mb-6 border border-gray-300 p-4 rounded-lg" data-id="element-28">
        <div className="font-semibold py-3 px-6 rounded-lg text-left w-full md:w-3/4 mb-4 text-lg" data-id="element-29">
          LIMITED STOCK OFFER:{' '}
          <a href="https://petssey.com/products/petssey-dnrx" className="text-blue-600 hover:underline" data-id="element-30">
            CLICK HERE TO CHECK AVAILABILITY
          </a>
        </div>
        <div className="bg-[#3b6998] text-white p-4 rounded flex items-center mb-4 w-full" data-id="element-31">
          <AlertTriangleIcon className="text-white mr-3 flex-shrink-0" size={24} data-id="element-32" />
          <p className="font-semibold m-0" data-id="element-33">
            IMPORTANT: Get Petssey DNRx for Every Room You Want to Eliminate Cat
            Hair Dander Allergens
          </p>
        </div>
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eNZaKK9Qr7V9RQFrWui7oA/ChatGPT_Image_Sep_2%2C_2025%2C_10_34_43_PM.png" alt="Close-up of Petssey DNRx air purifier device showing white design with blue light accent and ventilation holes" className="w-full h-auto object-cover rounded mb-4" data-id="element-34" />
        <p className="font-semibold text-center text-gray-500 mb-4" data-id="element-35">
          USE PETSSEY DNRX FOR FRESHER, CLEANER AIR
        </p>
        <a href="https://petssey.com/products/petssey-dnrx" className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg text-center w-full md:w-3/4 mb-4 text-lg" data-id="element-36">
          APPLY DISCOUNT & CHECK INVENTORY
        </a>
        <p className="text-center text-gray-500 mb-4" data-id="element-37">
          Limited Inventory Available
        </p>
      </div>
    </section>;
};